export default __webpack_public_path__ + "static/media/img_01.7e9bfdd4.webp";